const comFade = (() => {

  const fadeElem = document.querySelectorAll('.js-com-fade');
  if (fadeElem.length > 0) {

    for (let i = 0; i < fadeElem.length; i++) {

      gsap.set(fadeElem[i], {
        opacity: 0,
        y: 20,
      });

      gsap.to(fadeElem[i], {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power1.out",
        scrollTrigger: {
          trigger: fadeElem[i],
          start: 'top 80%'
        }
      });

    }

  }




  let animeTxt = document.querySelectorAll(".js-anime-txt");
  const comText = new SplitType(animeTxt);/*テキストの分割*/

  for (let i = 0; i < animeTxt.length; i++) {
    let animeTxtChar = animeTxt[i].querySelectorAll('.js-anime-txt .char');

    gsap.to(animeTxtChar, {
      y: 0 /*テキストのY軸の操作*/,
      stagger: 0.05 /*テキスト間の遅延時間*/,
      delay: 0.2 /*アニメーションのスタートまでの遅延時間*/,
      autoAlpha: 1,
      scrollTrigger: {
        trigger: animeTxt[i], // アニメーションが始まるトリガーとなる要素
        start: "top 80%", // アニメーションが始まる位置
        // markers: true, // マーカー表示
      }
    });
  }

})();
export default comFade;